import React, { useEffect, useState } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import DexterCall from "../Images/UpdatedDexter-call.svg";
import { ROUTE_BANK, ROUTE_EMAIL, ROUTE_MOBILE_VERIFICATION } from "../Routes";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import otherBanksList from "../Components/Banklist";
import Toast from "../Components/ToastMsg/Toast";
import { ToastContainer } from "react-toastify";
// import axios from "../libs/axiosConfig";
import { useDispatch, useSelector } from "react-redux";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { selectPanNumber } from "../Store/panNumberSlice";
// import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import { setBankName } from "../Store/UserBankSlice";
import LogoutModal from "../Components/LogoutModal";
import NewDexterLogo from "../Images/NewDexterLogo.svg";

const AccountType = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  // const { bankName, ADDRESS, BANK, BANKCODE, BRANCH } = location.state || {};
  const bankDetails = location.state ? location.state.bankDetails : null;
  console.log(bankDetails);
  // const address = bankDetails ? bankDetails.ADDRESS : null;
  // const bankCode = bankDetails ? bankDetails.BANKCODE : null;
  // const branch = bankDetails ? bankDetails.BRANCH : null;
  const bankName = bankDetails ? bankDetails.BANK : null;

  // console.log( bankName, ADDRESS, BANK, BANKCODE, BRANCH)
  const [formErrors, setFormErrors] = useState({});
  const [showOtherBanksList, setShowOtherBanksList] = useState(false);
  const [selectedOtherBank, setSelectedOtherBank] = useState("");
  const [selectedBank, setSelectedBank] = useState(bankName || "");
  const [showSuggestionss, setShowSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedBankOption, setSelectedBankOption] = useState(null);
  // const storedToken = useSelector((state) => state.storedToken.accessToken);
  // const phoneNumber = useSelector(selectPhoneNumber);

  // const panNumber = useSelector(selectPanNumber);

  const banknames = [
    { code: "AUB", billdeskcode: "AUB", name: "AU Small Finance Bank" },
    { code: "UTI", billdeskcode: "UTI", name: "Axis Bank Ltd" },
    {
      code: "BBR",
      billdeskcode: "BBR",
      name: "Bank of Baroda - Retail Banking",
    },
    { code: "BOI", billdeskcode: "BOI", name: "Bank of India" },
    { code: "BOM", billdeskcode: "BOM", name: "Bank of Maharashtra" },
    { code: "CNB", billdeskcode: "CNB", name: "Canara Bank" },
    { code: "CBI", billdeskcode: "CBI", name: "Central Bank of India" },
    { code: "DBK", billdeskcode: "DBK", name: "Deutsche Bank" },
    {
      code: "DLB",
      billdeskcode: "DLB",
      name: "Dhanalaxmi Bank - Retail Net Banking",
    },
    { code: "HDF", billdeskcode: "HDF", name: "HDFC Bank Ltd" },
    { code: "ICI", billdeskcode: "ICI", name: "ICICI Bank Ltd" },
    { code: "IDB", billdeskcode: "IDB", name: "IDBI Bank" },
    { code: "IDN", billdeskcode: "IDN", name: "IDFC First Bank" },
    { code: "IDS", billdeskcode: "IDS", name: "IndusInd Bank" },
    { code: "JSFB", billdeskcode: "JSFB", name: "Jana Small Finance Bank" },
    { code: "162", billdeskcode: "162", name: "Kotak Bank" },
    {
      code: "PNB",
      billdeskcode: "PNB",
      name: "Punjab National Bank - Retail Banking",
    },
    { code: "PSB", billdeskcode: "PSB", name: "Punjab and Sind Bank" },
    { code: "SOM", billdeskcode: "SOM", name: "SBM Bank India Ltd" },
    { code: "SIB", billdeskcode: "SIB", name: "South Indian Bank" },
    { code: "SCB", billdeskcode: "SCB", name: "Standard Chartered Bank" },
    { code: "SBI", billdeskcode: "SBI", name: "State Bank of India" },
    { code: "UBI", billdeskcode: "UBI", name: "Union Bank of India" },
    { code: "YBK", billdeskcode: "YBK", name: "Yes Bank Ltd" },
    { code: "BDN", billdeskcode: "BDN", name: "Bandhan Bank" },
    { code: "CUB", billdeskcode: "CUB", name: "City Union Bank" },
    { code: "COB", billdeskcode: "COB", name: "Cosmos Bank" },
    { code: "HSB", billdeskcode: "HSB", name: "HSBC" },
    { code: "IOB", billdeskcode: "IOB", name: "Indian Overseas Bank" },
    { code: "KVB", billdeskcode: "KVB", name: "Karur Vysya Bank" },
    { code: "UCO", billdeskcode: "UCO", name: "UCO Bank" },
  ];

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const handleBankDropdownToggle = () => {
    console.log("Dropdown button clicked!");
    setShowDropdown(!showDropdown);
    setShowOtherBanksList(false);

    const inputStart = (selectedBank || "").toLowerCase().substring(0, 5);

    const filteredSuggestions = banknames
      .map((item) => item.name)
      .filter((name) => {
        const lowerCaseItem = name.toLowerCase();
        const includesResult = lowerCaseItem.includes(inputStart);
        return includesResult;
      });

    console.log(filteredSuggestions);
    setShowSuggestions(filteredSuggestions);
  };

  useEffect(() => {
    if (bankName) {
      setSelectedBank(bankName);

      setShowSuggestions(
        banknames
          // .concat(otherBanksList)
          .filter(
            (item) =>
              item.toLowerCase().includes(bankName.toLowerCase()) &&
              item.toLowerCase() !== bankName.toLowerCase()
          )
      );
    }
  }, [bankName]);

  const handlebanknameChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setSelectedBank(input);

      const filteredSuggestions = banknames.filter((item) => {
        const lowerCaseItem = item.name.toLowerCase();
        return (
          lowerCaseItem.includes(input.toLowerCase()) &&
          lowerCaseItem !== input.toLowerCase()
        );
      });

      setShowSuggestions(filteredSuggestions);
      setShowDropdown(true);
    }
  };

  const handlebanknameSuggestionClick = (selectedBankName) => {
    const selectedBankDetails = banknames.find(
      (bank) => bank.name === selectedBankName
    );

    if (selectedBankDetails) {
      const { code, billdeskcode } = selectedBankDetails;
      console.log("Code:", code);
      console.log("Billdesk Code:", billdeskcode);
    }

    setSelectedBank(selectedBankName);
    dispatch(setBankName(selectedBankName));

    setShowSuggestions(false);
    setSelectedOtherBank("");
  };

  const handleOthersClick = () => {
    setShowOtherBanksList(false);
    setSelectedBankOption(null);
  };

  const handleOtherBankSelect = (selectedBank) => {
    setSelectedBank(selectedBank);
    setShowOtherBanksList(false);
    setSelectedOtherBank(selectedBank);
    setSelectedBankOption(selectedBank);
  };

  const HandleProceed = () => {
    if (!selectedBank) {
      Toast.error("Please enter & select a bank name.");
      return;
    }

    const selectedBankDetails = banknames.find(
      (bank) => bank.name === selectedBank
    );

    if (selectedBankDetails) {
      const { code, billdeskcode } = selectedBankDetails;
      const bankDetails = {
        bankName: selectedBank,
        bankCode: code,
        billdeskCode: billdeskcode,
      };
      dispatch(setBankName({ bankName: selectedBank ,bankCode: code}));
      Navigate(ROUTE_BANK, {
        state: { bankDetails: bankDetails ,bankCode: code},
      });
      console.log("bankDetails" ,bankDetails ,"bankCode" ,code )
    }
  };

  return (
    <div className="Accountype_Main_Container">
      <div className="Accounttype_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="at_Account_Container">
        <p className="Input_Heading_text">
          Finishing up bank details.{" "}
        </p>
        <span className="Input_Sub_heading">
          Almost there! Add remaining bank details.
        </span>
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">Bank name </span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.ifscCode ? classes.Error : ""
              }`}
              value={selectedBank}
              onChange={handlebanknameChange}
              onBlur={() => setShowDropdown(true)}
            />

            <button
              className="DropDown_button"
              onClick={handleBankDropdownToggle}
            />
          </div>
          {showDropdown && showSuggestionss.length > 0 && (
            <div className={classes.Suggestions_Container}>
              {showSuggestionss.map((bank, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion}
                  onClick={() =>
                    handlebanknameSuggestionClick(bank.name || bank)
                  }
                >
                  {bank.name || bank}
                </div>
              ))}
              {/* Show "Others" option */}
              {/* <div
                className={classes.Suggest_Suggestion}
                onClick={handleOthersClick}
              > */}
                {/* Others */}
              {/* </div> */}
            </div>
          )}

          {showOtherBanksList && (
            <div className={classes.Suggestions_Container}>
              {/* <p className={classes.SelectedBank_Text}>List of Other Banks:</p> */}
              <ul>
                {otherBanksList.map((bank, index) => (
                  <div
                    key={index}
                    onClick={() => handleOtherBankSelect(bank)}
                    className={
                      bank === selectedOtherBank || bank === selectedBankOption
                        ? classes.SelectedBank
                        : classes.Suggest_Suggestion
                    }
                  >
                    {bank}
                  </div>
                ))}
              </ul>
            </div>
          )}
        </div>

        <button className="Submit_button" onClick={HandleProceed}>
          Submit
        </button>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default AccountType;
